import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const NotebookIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 -1 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.3379 2.7002H20.6619C21.73 2.7002 22.5959 3.56752 22.5959 4.63747V16.3387L23.9502 20.1515C24.1492 20.7111 23.7347 21.3002 23.1412 21.3002H0.859201C0.265715 21.3002 -0.148814 20.7111 0.0501298 20.1516L1.4039 16.3404V4.63747C1.4039 3.56752 2.26976 2.7002 3.3379 2.7002ZM2.25686 16.9272L1.05938 20.2985H22.941L21.7435 16.9272H2.25686ZM21.5959 4.63747C21.5959 4.12074 21.1778 3.70189 20.6619 3.70189H3.3379C2.82204 3.70189 2.4039 4.12074 2.4039 4.63747V15.9255H21.5959V4.63747Z'
      />
    </svg>
  );
};
